export class Organization {
    Id: string;
    organizationName: string;
    isActive: number;
    createdBy: string;
    createdOn: string;
    updatedOn: string;
    updatedBy: string;
}


export interface OrgChartModel {
    globalCompetencyLeader: GlobalCompetencyLeader[];
    globalSubCompetencyLeader: Manager[];
    managers: Manager[];
  }
  
  export interface Manager {
    id: number;
    name: string;
    locationId: any;
    location: any;
    managerStream: any;
    managerRoleType: CompetencyManagerRoleType;
  }

  export enum CompetencyLeaderStream{

    peopleStream=1,
    functionalStream=2,
    technicalStream=3,

  }
  
  export enum CompetencyManagerRoleType {
    SkillMaturityManager = 1,
    ResourceManager = 2,
    InterviewPanelEnabler = 3,
    HiringManager = 4,
    GroupTechnicalManager = 5,
    CertificationEnabler = 6,
    KMSEnabler = 7,
    AcceleratorsAndIPEnabler = 8,
    NewsLetterEnabler = 9,
    EmergingTechnologySPOC = 10,
    ArchitectureSPOC = 11,
    DesignAndDevelopmentSPOC = 12,
    ToolsAndFrameworksSPOC = 13,
    TechAudit = 14
  }
  //update

  export interface GlobalCompetencyLeader {
    id: any;
    name: any;
  }
  
  export interface GlobalSubCompetencyLeader {
    id: any;
    name: any;
  }
    
  export interface SubCompetencyLeader {
    subCompetencyName: string;
    globalSubCompetencyLeader: GlobalSubCompetencyLeader[];
    locationManagers: Manager[];
  }
  
  export interface CompetencyData {
    competencyId: number;
    competencyName: string;
    globalCompetencyLeader: GlobalCompetencyLeader[];
    subCompetencyLeaders: SubCompetencyLeader[];
  }